import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutLocationList extends Layout {
    buttonFindNear: Button;
    buttonLocationToProspect: Button;
    layoutHeaderLocationList: LayoutHeader;
    sourceLocation: DataSource;
    tableSearch: Table;
}
